import { render, staticRenderFns } from "./tableProperties.vue?vue&type=template&id=5a0ffb53&scoped=true"
import script from "./tableProperties.vue?vue&type=script&lang=js"
export * from "./tableProperties.vue?vue&type=script&lang=js"
import style0 from "./tableProperties.vue?vue&type=style&index=0&id=5a0ffb53&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0ffb53",
  null
  
)

export default component.exports